import React from "react";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { IconButton } from "@mui/material";
import Interaction from "../../../models/interactions/Interaction";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import { navSliceActions } from "../../../store/slices/NavSlice";
import Tooltip from "@material-ui/core/Tooltip";
import Interval from "../../../models/communications/Interval";
import CommunicationSet from "../../../models/communications/CommunicationSet";
import { useTranslation } from "react-i18next";

interface InteractionDeleteButtonProps {
    handler: any;
    interaction?: Interaction;
    interval?: Interval;
    communicationSetID?: number | null
    communicationID?: number | null
    disabled?: boolean

}

const InteractionDeleteButton = (props: InteractionDeleteButtonProps) => {
    const dispatch = useStoreDispatch();
    const {t} = useTranslation();

    const deleteInteractionHandler = () => {
        if(props.communicationSetID){
            dispatch(
                navSliceActions.openModal({
                  caresenseModalAlertType : "communication_set_delete",
                  caresenseModalAlertMessage : "This action will permanently delete this communication set and all references to it from CareSense. Proceed?",
                  caresenseModalAlertEntityID : props.communicationSetID,
                  modalCallback: props.handler // post callback to redux so modal alert calls it on user approval
                }),
              );
        } else if (props.communicationID) { 
            dispatch(
                navSliceActions.openModal({
                    caresenseModalAlertType: "communication_delete",
                    caresenseModalAlertMessage:  "This action will permanently delete this communication and all references to it from CareSense. Proceed?",
                    caresenseModalAlertEntityID: props.communicationID,
                    modalCallback: props.handler // post callback to redux so modal alert calls it on user approval
                }),
            );
        } else {
            dispatch(
                navSliceActions.openModal({
                    caresenseModalAlertType: props.interval ? "interval_delete" : props.interaction ? props.interaction.properties.type + "_delete" : "unknown_delete",
                    caresenseModalAlertMessage: props.interval ? "This action will permanently delete this interval and all references to it from CareSense. Proceed?" : props.interaction ? "This action will permanently delete this " + props.interaction.properties.type + " and all references to it from CareSense. Proceed?" : "This action will permanently delete this interaction and all references to it from CareSense. Proceed?",
                    caresenseModalAlertEntityID: props.interval ? props.interval.id : props.interaction ? props.interaction.id : -0,
                    modalCallback: props.handler // post callback to redux so modal alert calls it on user approval
                }),
            );
        }

    }

    return (
        <Tooltip title={t("delete_label") + " " + (props.communicationID ?  t("communication_label") : props.communicationSetID ? t("communication_set_label") : props.interval ?  t("interval_label") : t("interaction_label")  ) }>
            <IconButton disabled={props.disabled || false} onClick={deleteInteractionHandler}>
                <DeleteForeverIcon style={{ color: "" }} />
            </IconButton>
        </Tooltip>
    );
};

export default InteractionDeleteButton;
